export const Model = Object.freeze({
	Bookings: 'bookings',
	Clients: 'clients',
	Counters: 'counters',
	Dictionary: 'dictionary',
	Favorites: 'favorites',
	FormsMenu: 'forms-menu',
	Interface: 'interface',
	MainResources: 'main-resources',
	MessageStatus: 'message-status',
	Notifications: 'notifications',
	ResourceCreationWizard: 'resource-creation-wizard',
	ResourceTypes: 'resourceTypes',
	Resources: 'resources',
	WaitList: 'wait-list',
	Filter: 'filter',
});
